import fb, { getDocsFromCollection } from '@/firebase'
import store from '@/store'

const state = {
  applications: null,
  allApplications: null,
  userApplications: null,
  assocApplications: null
}

const getters = {
  allApplications: state => state.allApplications,
  applications: state => state.applications,
  userApplications: state => state.userApplications,
  assocApplications: state => state.assocApplications
}

const mutations = {
  setApplications: (state, payload) => {
    state.applications = payload
  },
  setAllApplications: (state, payload) => {
    state.allApplications = payload
  },
  setUserApplications: (state, payload) => {
    state.userApplications = payload
  },
  setAssocApplications: (state, payload) => {
    state.assocApplications = payload
  }
}

const actions = {
  getApplications ({commit}, status) {
    store.dispatch('setLoaderStatus', true)
    fb.getApplications(status)
      .then(fetched => {
        commit('setApplications', getDocsFromCollection(fetched))
        store.dispatch('setLoaderStatus', false)
      })
  },
  getAllApplications ({commit}) {
    store.dispatch('setLoaderStatus', true)
    fb.getAllApplications()
      .then(fetched => {
        commit('setAllApplications', getDocsFromCollection(fetched))
        store.dispatch('setLoaderStatus', false)
      })
  },
  getUserApplications ({commit}, userRef) {
    store.dispatch('setLoaderStatus', true)
    fb.getUserApplications(userRef)
      .then(fetched => {
        commit('setUserApplications', getDocsFromCollection(fetched))
        store.dispatch('setLoaderStatus', false)
      })
  },
  getAssocApplications ({commit}, assocRef) {
    store.dispatch('setLoaderStatus', true)
    fb.getAssocApplications(assocRef)
      .then(fetched => {
        commit('setAssocApplications', getDocsFromCollection(fetched))
        store.dispatch('setLoaderStatus', false)
      })
  },
  addApplication ({commit}, payload) {
    store.dispatch('setLoaderStatus', true)
    fb.addApplication(payload.payload)
      .then((response) => {
        if (payload.userType === 'Student') {
          store.dispatch('getUser', payload.payload.userRef.id)
        } else if (payload.userType === 'Employee') {
          store.dispatch('getCanEdStudents')
        } else if (payload.userType === 'Associate') {
          store.dispatch('getStudents', payload.payload.userRef.id)
        }

        store.dispatch('setLoaderStatus', false)
        store.dispatch('setSuccessMessage', 'Applied Successfully')
        store.dispatch('getUserApplications', payload.payload.userRef)
      })
  },
  assignApplication: ({ commit }, params) => {
    store.dispatch('setLoaderStatus', true)
    fb.assignApplication(params.id, params.payload)
      .then(() => {
        store.dispatch('setLoaderStatus', false)
        store.dispatch('setSuccessMessage', 'Assigned application Successfully')
        store.dispatch('getAllApplications')
      })
  },
  submittedApplication: ({ commit }, params) => {
    store.dispatch('setLoaderStatus', true)
    fb.applicationSetStatus(params.id, params.payload)
      .then(() => {
        store.dispatch('setLoaderStatus', false)
        store.dispatch('setSuccessMessage', 'Application submitted status marked Successfully')
        store.dispatch('getAllApplications')
        // params.status.forEach(status => store.dispatch('getApplications', status))        
      })
  },
  applicationSetStatus: ({ commit }, params) => {
    store.dispatch('setLoaderStatus', true)
    fb.applicationSetStatus(params.id, params.payload)
      .then(() => {
        store.dispatch('setLoaderStatus', false)
        store.dispatch('setSuccessMessage', 'Application status saved successfully')
        store.dispatch('getAllApplications')
        // params.status.forEach(status => store.dispatch('getApplications', status))        
      })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/applications.js